import React from 'react';
import { addRouteNamespace } from '@Utils/actions';
import LanguageIcon from '@mui/icons-material/Language';
import { AGSet, AGSets, AutomaticSetup } from '.';

export const mainPageRoutes = [
	{
		title: 'Automatic Setup',
		to: addRouteNamespace('setup'),
		render: <AutomaticSetup />,
	},
	{
		title: 'Details',
		to: addRouteNamespace('details/:treeId'),
		render: <AGSet />,
	},
	{
		title: 'New Asset Group Set',
		to: addRouteNamespace('new'),
		render: <AGSet />,
	},
];

export const miniPageRoutes = [
	{
		title: 'Groups',
		to: '/agsets',
		icon: <LanguageIcon />,
		render: <AGSets />,
	},
	...mainPageRoutes,
];

export default [mainPageRoutes, miniPageRoutes];
